const fullAddress = (address) => {
  if (!address) return 'Sem endereço.'

  return `${address.street}, ${address.number}, ${address.complement}, ${address.neighborhood}, ${address.zipcode}, ${address.city}-${address.state}`
}

export default fullAddress
